import React, { useState, useEffect } from 'react';
import {
  PlatformSection,
  PlatformTitle,
  VideoContainer,
  VideoOverlay,
  PlayButton,
  VideoFrame
} from './PlatformVideoStyles';

// JavaScript function to open video in a new window with a native player in fullscreen mode
function openNativePlayerWindow(videoSrc) {
  // This function will be injected into the new window to control the video
  const playerScript = `
    document.addEventListener('DOMContentLoaded', function() {
      const video = document.getElementById('fullscreen-video');
      if (video) {
        video.controls = true;
        
        // Try to play automatically
        video.play().catch(function(e) { 
          console.warn('Could not play automatically:', e); 
        });
        
        // Handle window closing
        window.addEventListener('unload', function() {
          try {
            if (window.opener && !window.opener.closed) {
              window.opener.postMessage({
                type: 'fullscreenClosed'
              }, '*');
            }
          } catch(e) {
            console.warn('Error communicating with main window:', e);
          }
        });
      }
    });
  `;

  // Simple HTML for the new window with native player
  const playerHTML = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>BIANCA - Inside the Platform</title>
      <style>
        body, html { 
          margin: 0; 
          padding: 0; 
          width: 100%; 
          height: 100%; 
          overflow: hidden;
          background-color: #000;
        }
        #fullscreen-video {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      </style>
      <script>${playerScript}</script>
    </head>
    <body>
      <video id="fullscreen-video" src="${videoSrc}" autoplay controlsList="nodownload" disablePictureInPicture></video>
    </body>
    </html>
  `;

  // Open a new window with maximum possible size
  const windowFeatures = "popup,fullscreen=yes,width=" + window.screen.width + ",height=" + window.screen.height;
  const playerWindow = window.open("", "videoPlayer", windowFeatures);
  
  if (playerWindow) {
    playerWindow.document.write(playerHTML);
    playerWindow.document.close();
    
    // Focus on new window
    playerWindow.focus();
    
    return playerWindow;
  }
  
  return null;
}

const PlatformVideoSectionUS = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [playerWindow, setPlayerWindow] = useState(null);
  const videoUrl = process.env.PUBLIC_URL + '/videos/bianca_demo.mp4'; // Path to local video
  
  // Message back from fullscreen window
  useEffect(() => {
    const handleMessage = (event) => {
      // Check if message came from player window
      if (playerWindow && event.source === playerWindow) {
        const data = event.data;
        
        if (data && data.type === 'fullscreenClosed') {
          // Reset to thumbnail state
          setIsPlaying(false);
          setPlayerWindow(null);
        }
      }
    };
    
    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [playerWindow]);
  
  // Check if fullscreen window was closed
  useEffect(() => {
    if (playerWindow) {
      const checkWindow = setInterval(() => {
        if (playerWindow && playerWindow.closed) {
          setIsPlaying(false);
          setPlayerWindow(null);
          clearInterval(checkWindow);
        }
      }, 500);
      
      return () => {
        clearInterval(checkWindow);
      };
    }
  }, [playerWindow]);
  
  const handlePlayClick = () => {
    // Get absolute video URL
    const videoPath = new URL(videoUrl, window.location.origin).href;
    
    // Open new window with native player in fullscreen
    const newWindow = openNativePlayerWindow(videoPath);
    
    if (newWindow) {
      setPlayerWindow(newWindow);
      setIsPlaying(true);
    } else {
      // If unable to open window, show alert
      alert('Could not open fullscreen mode. Please check if pop-ups are allowed.');
    }
  };
  
  return (
    <PlatformSection>
      <PlatformTitle>INSIDE THE PLATFORM</PlatformTitle>
      
      <VideoContainer>
        {/* Overlay with play button that remains visible since video opens in another window */}
        <VideoOverlay isPlaying={false} onClick={handlePlayClick}>
          <PlayButton />
        </VideoOverlay>
      </VideoContainer>
    </PlatformSection>
  );
};

export default PlatformVideoSectionUS;
